<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="paginator">
    <!-- First Page Button -->
    <button
      :disabled="currentPage === 1 || disabled"
      class="paginator-button paginator-first"
      @click="changePage(1)"
      :aria-label="firstPageLabel"
    >
      <span class="icon pagination-first-icon"></span>
    </button>

    <!-- Previous Page Button -->
    <button
      :disabled="currentPage === 1 || disabled"
      class="paginator-button paginator-prev"
      @click="changePage(currentPage - 1)"
      :aria-label="prevPageLabel"
    >
      <span class="icon pagination-prev-icon"></span>
    </button>

    <!-- Current Page Report -->
    <div class="paginator-report">{{ recordRange }}</div>

    <!-- Next Page Button -->
    <button
      :disabled="
        currentPage > 0 &&
        (currentPage - 1) * rowsStoreFirstime + rows == totalRecords
      "
      class="paginator-button paginator-next"
      @click="changePage(currentPage + 1)"
      :aria-label="nextPageLabel"
    >
      <span class="icon pagination-next-icon"></span>
    </button>

    <!-- Last Page Button -->
    <button
      :disabled="(currentPage - 1) * rowsStoreFirstime + rows == totalRecords"
      class="paginator-button paginator-last"
      @click="changePage(actualTotalPages)"
      :aria-label="lastPageLabel"
    >
      <span class="icon pagination-last-icon"></span>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageNumber: 1,
      rowsStoreFirstime: 50,
    };
  },
  props: {
    totalRecords: {
      type: Number,
      default: 0,
    },
    rows: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    firstPageLabel: {
      type: String,
      default: "First Page",
    },
    prevPageLabel: {
      type: String,
      default: "Previous Page",
    },
    nextPageLabel: {
      type: String,
      default: "Next Page",
    },
    lastPageLabel: {
      type: String,
      default: "Last Page",
    },
  },
  async mounted() {
    if (this.currentPage == 1) {
      this.rowsStoreFirstime = this.rows;
    }
    //console.log(this.totalRecords, "this.totalRecords");
    //console.log(this.rowsStoreFirstime, "this.rowsStoreFirstime");
    if (
      this.currentPage > 0 &&
      this.totalRecords > 0 &&
      this.rowsStoreFirstime > 0
    ) {
      this.pageNumber = Math.ceil(this.totalRecords / this.rowsStoreFirstime);
    }
  },
  emits: ["update:page", "page"],
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(value) {
        this.$emit("update:page", value);
      },
    },
    actualTotalPages() {
      // Calculate actual total pages based on total records
      return Math.ceil(this.totalRecords / this.rows) || 1;
    },
    remainingRecords() {
      const recordsUsed = this.currentPage * this.rows;
      return this.totalRecords - recordsUsed;
    },
    recordRange() {
      // Calculate the range of records for the current page
      if (this.totalRecords === 0 || this.rows === 0) return "0-0 of 0";
      const start = (this.currentPage - 1) * this.rowsStoreFirstime + 1;
      const end = Math.min(start + this.rows - 1, this.totalRecords);
      return `${start}-${end} of ${this.totalRecords}`;
    },
  },
  methods: {
    changePage(page) {
      // Ensure page is within valid range
      const validPage = Math.min(Math.max(1, page), this.actualTotalPages);

      if (validPage !== this.currentPage) {
        this.currentPage = validPage;
        this.$emit("page", {
          page: validPage - 1,
          rows: this.rows,
          first: (validPage - 1) * this.rows,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.paginator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  font-family: "voyado Text", sans-serif;
  font-size: 14px;
  color: #2d6e6d;
}

.paginator-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 0.6px solid #e0e0e0;
  background: #ffffff;
  cursor: pointer;
  color: #2d6e6d;
  transition: background-color 0.2s, border-color 0.2s;

  &:hover:not(:disabled) {
    background: #e9ecef;
    border-color: #dee2e6;
    color: #2d6e6d;
    box-shadow: none;
  }

  &:enabled:focus {
    outline-offset: 0;
    border-style: double;
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.paginator-report {
  font-size: 14px;
  color: #388988;
  font-weight: 500;
  height: 40px;
  border: 0.5px solid #dee2e6;
  padding: 12px 10px 0px 10px;
}

.icon {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
